import { PayloadAction } from "@reduxjs/toolkit";
import {
  ExportFormatEnum,
  WhatToExportEnum,
} from "app/containers/Features/containers/Boards/components/Settings/types";
import { EffortEstimatedPayload } from "app/containers/Features/types";
import { createSlice } from "utils/@reduxjs/toolkit";
import {
  IAssignTicketsToComponentResponse,
  IAssignTicketsToEpicResponse,
  IAssignTicketsToStoryResponse,
  IAssignTicketsToSprintResponse,
  ITicketResponse,
  ITicketTagsResponse,
} from "../types";
import { initialState } from "./initialState";

const useClinicSlice = createSlice({
  name: "ticketFieldsUpdate",
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isTicketUpdating = action.payload;
    },
    ticketNameUpdate: (
      state,
      action: PayloadAction<{
        data: ITicketResponse;
        callback: () => void;
      }>,
    ) => {},
    assigneeUpdate: (
      state,
      action: PayloadAction<{
        hideToast?: boolean;
        data: ITicketResponse;
        callback: () => void;
      }>,
    ) => {},
    statusUpdate: (
      state,
      action: PayloadAction<{
        hideToast?: boolean;
        data: ITicketResponse;
        callback: () => void;
      }>,
    ) => {},
    ticketTypeUpdate: (
      state,
      action: PayloadAction<{
        hideToast?: boolean;
        data: ITicketResponse;
        callback: () => void;
      }>,
    ) => {},
    priorityUpdate: (
      state,
      action: PayloadAction<{
        hideToast?: boolean;
        data: ITicketResponse;
        callback: () => void;
      }>,
    ) => {},
    effortEstimationUpdate: (
      state,
      action: PayloadAction<{
        effortEstimated: EffortEstimatedPayload;
        projectId: string;
        ticketId: string;
        callback: () => void;
      }>,
    ) => {},
    dueDateUpdate: (
      state,
      action: PayloadAction<{
        hideToast?: boolean;
        data: ITicketResponse;
        callback: () => void;
      }>,
    ) => {},
    ticketTagsUpdate: (
      state,
      action: PayloadAction<{
        hideToast?: boolean;
        data: ITicketTagsResponse;
        callback: () => void;
      }>,
    ) => {},
    effortActualUpdate: (
      state,
      action: PayloadAction<{
        hideToast?: boolean;
        data: ITicketResponse;
        callback: () => void;
      }>,
    ) => {},
    assignTicketsToComponentUpdate: (
      state,
      action: PayloadAction<{
        hideToast?: boolean;
        data: IAssignTicketsToComponentResponse;
        callback: () => void;
      }>,
    ) => {},
    assignTicketsToSprintUpdate: (
      state,
      action: PayloadAction<{
        hideToast?: boolean;
        data: IAssignTicketsToSprintResponse;
        callback: () => void;
      }>,
    ) => {},
    assignTicketsToEpicUpdate: (
      state,
      _action: PayloadAction<{
        data: IAssignTicketsToEpicResponse;
        callback: () => void;
      }>,
    ) => {},
    assignTicketsToStoryUpdate: (
      state,
      _action: PayloadAction<{
        data: IAssignTicketsToStoryResponse;
        callback: () => void;
      }>,
    ) => {},
    exportSelectedTickets: (
      state,
      action: PayloadAction<{
        id: string;
        ticketIds: string[];
        fileFormat: ExportFormatEnum;
        exportScope: WhatToExportEnum;
        callback?: (data: Blob) => void;
      }>,
    ) => {
      state.isBulkExporting = true;
    },
    setIsBulkExporting: (state, action: PayloadAction<boolean>) => {
      state.isBulkExporting = action.payload;
    },
  },
});

export const { reducer, actions, name: sliceKey } = useClinicSlice;
